class SaveNotes {

    constructor() {
      this.form = document.querySelector('.js-application-notes')
	  this.websiteChecked = document.querySelector('#website_checked');
    }
  
    init() {
      this.events()
    }
  
    events() {

		if ( this.form ) {
			
			this.form.addEventListener('submit', ( ev ) => {
				ev.preventDefault()
				this.saveResults( ev.target.dataset.postId )
				.then( ( response ) => {
					console.log( response.ok )
				})
			})

		}
  
    }
  
    async saveResults ( postId ) {
		let websiteChecked = 0;
		if ( this.websiteChecked.checked ) {
			websiteChecked = 1;
		}

		const form = new FormData();
		form.append('action', 'save_notes');
		form.append('postId', postId);
		form.append('internal_notes_summary_of_request', this.form.elements['summary_of_request'].value);
		form.append('internal_notes_other_notes', this.form.elements['other_notes'].value);
		form.append('internal_notes_website_checked', websiteChecked);
		form.append('internal_notes_recommended_funding_amount', this.form.elements['recommended_funding_amount'].value);
		form.append('nonce', main_js.nonce);

		const response = await fetch(main_js.ajaxurl, {
			method: 'POST',
			body: form,
			credentials: 'same-origin',
		});

		return response

    }

  }
  
  export default SaveNotes
  